import { Api } from './Api';

export default {
    getLogFiles (body) {
        return Api().post(`/LogFile/SearchLogFiles`, body);
    },
    getLogFile (id) {
        return Api().get(`/LogFile/${id}`);
    },
}